import { Injectable } from '@angular/core';

@Injectable()
export class RoutingHistoryService {
  private history = [];
  constructor() { }

  public getHistory(): string[] {
    return this.history;
  }
  /**
   * append the current url to the history array
   * @param urlAfterRedirects
   */
  public addCurrentUrl(urlAfterRedirects: string): void {
    this.history = [...this.history, urlAfterRedirects];
    // console.log('history = ' + this.history.toLocaleString());
  }
  /**
   * check the previous url (just returning this previous url)
   */
  public checkPreviousUrl(): string {
    const previousIdx = this.history.length - 2;
    const previousUrl = (previousIdx >= 0) ?  this.history[previousIdx] : '/';
    return previousUrl;
  }

  /**
   * pop the previous url, which means to remove the current urls at the same time
   */
  public popPreviousUrl(): string {
    const previousIdx = this.history.length - 2;
    const previousUrl = (previousIdx >= 0) ?  this.history[previousIdx] : '/';
    // remove the current url
    if (previousIdx >= 0) {
      this.history.splice(previousIdx + 1, 1);
    }
    return previousUrl;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/routing-history.service.ts